
import { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../common/Button"
import Card from "../../../common/Card"
import CheckboxCell from "../../../common/interactive/CheckboxCell"
import TextareaBox from "../../../common/interactive/TextareaBox"
import CopyText from "../../../fragments/CopyText"
import PannelBody from "../../../fragments/PannelBody"
import PannelHeader from "../../../fragments/PannelHeader"
import DatepickerWithLabel from "../../../common/interactive/DatepickerWithLabel"
import { noteAsignTypesOptions, notePriorityOptions, noteTeamsOptions, noteTypesOptions, retrieveAllWorkQsAsOptions, retrieveAllWorkQsCleaned } from "../../../../lib/systemData"
import { createNoteApi, getAllUsers, resolveTask} from "../../../../lib/fetchApi"
import { notificationActions } from "../../../../store/notifications"
import { caseActions } from "../../../../store/case"
import CustomSelect from "../../../common/interactive/CustomSelect"
import { addDaysAndReturnNewDate } from "../../../../lib/dateScripts"
import { formatDate } from "../../../../lib/script"
import { formatPatientName } from "../../../../lib/patientName"
import FalseInputSearch from "../GroupNew/FalseInputSearch"
import { userActions } from "../../../../store/user"
import CustomSelectMultiple from "../../../common/interactive/CustomSelectMultiple"
import { tasksActions } from "../../../../store/tasks"
import { canUseNoteTypeId, filterNoteTypesByPermission } from "../../../../lib/notesPermissions"

import classes from './AddNotes.module.css'
import { LinkToNotesTypes } from "./LinkToNotesTypes"
import { useParams } from "react-router-dom"

const AddNotes = ({closeModal, selectedNoteTypeId, directData, inWorkQ, workqId, forced, modalTitle, preselectedValues, preSelectedResolvedNotes, isInTaskListing, workq}) => {
    const dispatch = useDispatch()
    const editPermissions = useSelector(state => state.permissions.editPermissions)
    const permittedNoteTypes = useMemo(
        () => filterNoteTypesByPermission(noteTypesOptions() || [], editPermissions),
        [editPermissions]
    )
    const effectiveSelectedNoteTypeId = canUseNoteTypeId(selectedNoteTypeId, editPermissions)
        ? selectedNoteTypeId
        : null
    const [covertToTask, setConvertToTask] = useState(forced && forced == 'task' ? true : false);
    const [noteTypeId, setNoteTypeId] = useState(effectiveSelectedNoteTypeId)
    const [actionRequiredId, setActionRequiredId] = useState(null)

    const selectedWorkQueue = useSelector((state) => state.workqueue.selectedWorkQueue);

    const [isLoading, setIsLoading] = useState(false)

    const [selectedDate, setSelectedDate] = useState(null)

    const [hasErrors, setHasErrors] = useState(false)

    const [filteredNoteActions, setFilteredNoteActions] = useState(null)
    const [filteredNoteActionsText, setFilteredNoteActionsText] = useState(null)
    const [taskPriority, setTaskPriority] = useState('Low')
    const [taskAsignTo, setTaskAsignTo] = useState(null)
    const [asignToUser, setAsignToUser] = useState(null)
    const [asignToTeam, setAsignToTeam] = useState(null)
    const [asignToWorkQueue, setAsignToWorkQueue] = useState([])


    
    let { workqSlug } = useParams();

    useEffect(() => {
        if (workqSlug) {
            let workQid = retrieveAllWorkQsCleaned().find(item => item.slug == workqSlug)?.id
            if (workQid) {
                setAsignToWorkQueue([...asignToWorkQueue, workQid])
            }
        }
    }, [workqSlug])

    const allUsersFromStore = useSelector(state => state.user.allUsers)

    let activeCase = useSelector(state => state.case.activeCase)

    if (directData) {
        activeCase = directData
    }
    const userToken = useSelector(state => state.user.token)
    let currentWorkQ = workq || selectedWorkQueue
    const permittedWorkQNoteTypes = useMemo(
        () => (currentWorkQ?.note_types || []).filter((id) => canUseNoteTypeId(id, editPermissions)),
        [currentWorkQ?.note_types, editPermissions]
    )

    const closeModalHandler = () => {
        if (closeModal) {
            closeModal()
        }
    }

    function setNoteTypeHandler(nextNoteTypeId) {
        if (!canUseNoteTypeId(nextNoteTypeId, editPermissions)) {
            return
        }
        setNoteTypeId(nextNoteTypeId)
        setFilteredNoteActions(permittedNoteTypes.find(item => item.value == nextNoteTypeId)?.note_actions?.map(item => {
            return {
                label: item.name,
                value: item.id,
                isDisabled: item.active == 0 ? 1 : 0,
                ...item
            }
        }))
    }

    const setNoteTypehandler = (value) => {
        setNoteTypeId(value.data.value)

        if (value && value.option && value.option.note_actions) {
            setFilteredNoteActions(value.option.note_actions.map(item => {
                return {
                    label: item.name,
                    value: item.id,
                    isDisabled: item.active == 0 ? 1 : 0,
                    ...item
                }
            }))

        }
    }

    const setActionRequiredHandler = (value) => {
        setActionRequiredId(value.data.value)

        let priorityHasDueDate = notePriorityOptions()?.find(item => item.value == taskPriority)?.due_days

        if (value && value.option && value.option.due_days && !priorityHasDueDate) {
            setSelectedDate(formatDate(addDaysAndReturnNewDate(value.option.due_days)))            
        }

        if (value && value.option && value.option.note_template && !filteredNoteActionsText) {
            setFilteredNoteActionsText(value.option.note_template)
        }
    }

    function setPriorityHandler(value) {

        setTaskPriority(value.data.value)
        if (value && value.option && value.option.due_days) {
            setSelectedDate(formatDate(addDaysAndReturnNewDate(value.option.due_days)))            
        }
    }

    function setNotesHandler(value) {
        setFilteredNoteActionsText(value.data.value)
    }

    const convertToTaskHandler = (value) => {
        setConvertToTask(value.data.value)
        if (!value.data.value) {
            setSelectedDate(null)
            setActionRequiredId(null)
        }
    }

    const setDateHandler = (value) => {
        setSelectedDate(value.data.value)
    }

    function setAsignToHandler(value) {
        setTaskAsignTo(value.data.value)
    }

    function setAsignToUserHandler(value) {
        setAsignToUser(value.data.value)
    }

    function setAsignToTeamHandler(value) {
        setAsignToTeam(value.data.value)
    }

    function setAsignToWorkQueueHandler(value) {
        setAsignToWorkQueue(value.data.value)
    }

    const handleNoteCreated = (create) => {
        if (create?.errorMessage) {
            dispatch(notificationActions.setError(create))
            return
        }
        if (closeModal) {
            closeModal()
        }
        if (create?.id && !inWorkQ && !isInTaskListing) {
            dispatch(caseActions.pushWholeItemInArray({
                folder: 'notes',
                item: create,
                itemId: create.id,
            }))
        }
    }

    const submitHandler = async (event) => {
        event.preventDefault()
        setIsLoading(true)

        try {
            // ######### resolve the task first if it comes from resolve a task ##############
            if (preSelectedResolvedNotes && preselectedValues) {
                let reqBody = {
                    note: preSelectedResolvedNotes
                }

                let resolve = await resolveTask(userToken, preselectedValues.id, reqBody, inWorkQ ? workqId : null, inWorkQ ? dispatch : null, inWorkQ ? activeCase?.case?.id : null)
                if (resolve && resolve.errorMessage) {
                    dispatch(notificationActions.setError(resolve))
                } else {
                    dispatch(notificationActions.setError({errorMessage: `Task Resolved`, type: 'success'}))

                    if (inWorkQ) {
                        // ################# when in work q there is nothing to do since dispatch in resolveTask takes care of everything!  #################
                    } else if (isInTaskListing) {
                        dispatch(tasksActions.setRefreshApi())
                    } else if (resolve) {
                        dispatch(caseActions.pushWholeItemInArray({
                            folder: 'notes',
                            itemId: resolve.id,
                            item: resolve,
                        }))
                    }
                }
            }
            // ######### resolve the task first if it comes from resolve a task ##############

            const fd = new FormData(event.target)
            const data = Object.fromEntries(fd.entries())

            const reqBody = {
                note_type_id: noteTypeId,
                note: data.notes_textarea,
                is_task: covertToTask,
                note_action_id: covertToTask ? actionRequiredId : null,
                due_date: covertToTask ? selectedDate : null,
                priority: covertToTask ? taskPriority : null,
                assignee_type: covertToTask ? taskAsignTo : null,
                work_queue_ids: covertToTask ? asignToWorkQueue : null,
            }

            if (taskAsignTo == 'User') {
                reqBody.assignee_users = asignToUser
            }

            if (taskAsignTo == 'Team') {
                reqBody.assignee_teams = asignToTeam
            }

            if ((noteTypeId !== null) && data.notes_textarea && canUseNoteTypeId(noteTypeId, editPermissions)) {
                if (covertToTask) {
                    if ((actionRequiredId !== null) && selectedDate) {
                        setHasErrors(false)
                        const create = await createNoteApi(userToken, activeCase.case.id, reqBody, workqId, workqId ? dispatch : null)
                        handleNoteCreated(create)
                    } else {
                        setHasErrors(true)
                    }
                } else {
                    setHasErrors(false)
                    const create = await createNoteApi(userToken, activeCase.case.id, reqBody, workqId, workqId ? dispatch : null)
                    handleNoteCreated(create)
                }
            } else {
                setHasErrors(true)
            }
        } finally {
            setIsLoading(false)
        }
    }


    useEffect(() => {
        if (!canUseNoteTypeId(noteTypeId, editPermissions)) {
            setNoteTypeId(null)
        }
    }, [editPermissions, noteTypeId])

    useEffect(() => {
        if (effectiveSelectedNoteTypeId) {
            setNoteTypeId(effectiveSelectedNoteTypeId)
            let preSelectedNoteType = permittedNoteTypes.find(item => item.value == effectiveSelectedNoteTypeId)
            if (preSelectedNoteType && preSelectedNoteType.note_actions) {
                setFilteredNoteActions(preSelectedNoteType.note_actions.map(item => {
                    return {
                        label: item.name,
                        value: item.id,
                        isDisabled: item.active == 0 ? 1 : 0,
                        ...item
                    }
                }))
            }
        } else if (selectedNoteTypeId && !canUseNoteTypeId(selectedNoteTypeId, editPermissions)) {
            setNoteTypeId(null)
        }
    }, [effectiveSelectedNoteTypeId, selectedNoteTypeId, editPermissions, permittedNoteTypes])

    useEffect(() => {

        if (preselectedValues) {
            const preselectedTypeId = canUseNoteTypeId(preselectedValues.note_type_id, editPermissions)
                ? preselectedValues.note_type_id
                : null

            setConvertToTask(true)
            setNoteTypeId(preselectedTypeId)
            if (preselectedValues.priority) {
                setTaskPriority(preselectedValues.priority)
            }
            setFilteredNoteActionsText(preselectedValues.note)
            setTaskAsignTo(preselectedValues.assignee_type)

            if (preselectedValues.assignee_type) {
                if (preselectedValues.assignee_type == "User" && preselectedValues.assignee_users && preselectedValues.assignee_users.length) {
                    setAsignToUser(preselectedValues.assignee_users.map(item => item.id))
                }

                if (preselectedValues.assignee_type == "Team" && preselectedValues.assignee_teams && preselectedValues.assignee_teams.length) {
                    const activeTeamIds = new Set((noteTeamsOptions() || []).map(item => String(item.value ?? item.id)))
                    setAsignToTeam(
                        preselectedValues.assignee_teams
                            .map(item => item.id)
                            .filter(id => activeTeamIds.has(String(id)))
                    )
                }
            }

            

            let preSelectedNoteType = permittedNoteTypes.find(item => item.value == preselectedTypeId)
            let actionItem
            if (preSelectedNoteType && preSelectedNoteType.note_actions) {
                actionItem = preSelectedNoteType.note_actions.find(item => item.id == preselectedValues.note_action_id)
                setFilteredNoteActions(preSelectedNoteType.note_actions.map(item => {
                    return {
                        label: item.name,
                        value: item.id,
                        ...item
                    }
                }))
            }

            setActionRequiredId(preselectedTypeId != null ? preselectedValues.note_action_id : null)

            let priorityHasDueDate = notePriorityOptions()?.find(item => item.value == preselectedValues.priority)?.due_days

            if (priorityHasDueDate) {
                setSelectedDate(formatDate(addDaysAndReturnNewDate(priorityHasDueDate)))
            } else if (actionItem?.due_days) {
                setSelectedDate(formatDate(addDaysAndReturnNewDate(actionItem.due_days)))            
            }
            

        }

    }, [preselectedValues, editPermissions, permittedNoteTypes])


    useEffect(() => {

        async function getAndSetAllUsers() {
            let allUsers
            if (!allUsersFromStore) {
                allUsers = await getAllUsers(userToken)
            } else {
                allUsers = allUsersFromStore
            }
                
            if (allUsers && allUsers.errorMessage) {
                dispatch(notificationActions.setError(allUsers))
            } else {
                let users = allUsers.map(item => {
                    return {
                        ...item,
                        value: item.id,
                        label: item.name
                    }
                })
                dispatch(userActions.setAllUsers(users))
            }
        }

        getAndSetAllUsers()

        if (!effectiveSelectedNoteTypeId && permittedWorkQNoteTypes.length === 1) {
            setNoteTypeHandler(permittedWorkQNoteTypes[0])
        }
        
    }, [])

    return <Card>
        <div className={classes.container}>
            <PannelHeader padding='large'>
                <div className={classes.flex_container}>
                    <h2>{modalTitle ? modalTitle : 'Add a note / task'}</h2>
                    <button onClick={closeModalHandler} className={classes.close_modal}>
                        <i className="ti ti-x"></i>
                        <span className="sr-only">close modal</span>
                    </button>
                </div>
            </PannelHeader>
            <div className={classes.pacient_details_info}>
                <div className={classes.name}>
                    {directData && <>{directData.patient.name}</>}
                    {!directData && <>{formatPatientName(activeCase.patient)}</>}    
                                  
                </div>
                <div className={classes.copy_text_box}>
                    Case: 
                    <CopyText text={activeCase.case.id}/>
                </div>
            </div>
{/* && currentWorkQ?.note_types?.length > 0 */}
            {currentWorkQ && permittedWorkQNoteTypes.length > 0 && <LinkToNotesTypes currentWorkQ={currentWorkQ} noteTypes={permittedWorkQNoteTypes} setNoteTypeHandler={setNoteTypeHandler}/>}


            <PannelBody padding='large'>
                <form onSubmit={submitHandler}>
                    {!forced && <div className={classes.item}>
                        <CheckboxCell label={'Convert this into a task'} name={'convert_to_task'} direction={'reverse'} action={convertToTaskHandler} checked={preselectedValues ? true : false}/>
                    </div> } 
                    <div className={`${classes.item} ${covertToTask ? classes.item_grid : ''}`}>
                        <div>
                            <CustomSelect label='Note Type' name={'note_type'} optionsData={permittedNoteTypes} preSelectedValue={noteTypeId ? noteTypeId : effectiveSelectedNoteTypeId} action={setNoteTypehandler} required={true}/>
                        </div>
                        {covertToTask && <div>
                            {filteredNoteActions && <CustomSelect label='Action Required' name={'action_required'} optionsData={filteredNoteActions} preSelectedValue={actionRequiredId} action={setActionRequiredHandler} isDisabled={!filteredNoteActions}/>}
                            {!filteredNoteActions && <FalseInputSearch label={'Action Required'} value={null}/>}
                        </div>}
                    </div>  
                    {covertToTask && <div className={`${classes.item} ${classes.item_grid}`}>                       
                      
                        <div>
                            <CustomSelect label='Priority' name={'priority'} optionsData={notePriorityOptions()} preSelectedValue={taskPriority} action={setPriorityHandler}/>
                        </div> 
                        <div>
                            <DatepickerWithLabel defaultDate={selectedDate}  label='Due Date' name={'due_date_picker'} action={setDateHandler} required={true} minDate={new Date()} onlyWeekDayes={true}/>
                        </div> 
                    </div> } 
                    
                    <div className={classes.item}>
                        <TextareaBox label={'Notes'} name={'notes_textarea'} currentValue={filteredNoteActionsText} action={setNotesHandler} required={true}/> 
                    </div>     

                    {covertToTask && <div className={`${classes.item} ${classes.item_grid}`}>
                        <div>
                            <CustomSelect label='Assign To' name={'asign_to'} optionsData={noteAsignTypesOptions()} preSelectedValue={taskAsignTo} action={setAsignToHandler} hasRemove={true}/>
                        </div>
                        {taskAsignTo == 'User' && <div>
                            <CustomSelectMultiple label="Users" name={'users'} optionsData={allUsersFromStore} preSelectedValue={asignToUser} action={setAsignToUserHandler}/>
                        </div>}
                        {taskAsignTo == 'Team' && <div>
                            <CustomSelectMultiple label='Team' name={'team'} optionsData={noteTeamsOptions()} preSelectedValue={asignToTeam} action={setAsignToTeamHandler}/>
                        </div>}

                        <div>
                            <CustomSelectMultiple label='Work Queue' name={'work_queue'} optionsData={retrieveAllWorkQsAsOptions()} preSelectedValue={asignToWorkQueue} action={setAsignToWorkQueueHandler}/>
                        </div>
                    </div> }
                        
                     
                    {hasErrors && <div className={classes.item}>
                        <span className="danger small">There are some missing fields. PLease Review</span>
                    </div> }
                    <div className={classes.item}>
                        <Button isLoading={isLoading}>
                            {preselectedValues ? <>
                                Resolve and Submit <i className="ti ti-chevron-right"></i>
                            </>
                            :
                            <>Submit <i className="ti ti-chevron-right"></i></>
                            }
                            
                        </Button>   
                    </div>                     
                </form>                
            </PannelBody>
        </div>
    </Card>
}

export default AddNotes